import { Input } from "@mui/material";
import { PropsWithChildren, useEffect, useState } from "react";

export function EditableTextField({
  displayText,
  setDisplayText,
  doubleClick = false,
  editorRole,
  onCancel,
  onEdit,
  disableEdit = false,
  multiline = false,
  startInEdit = false,
  children,
}: {
  displayText: string;
  setDisplayText: (text: string) => void;
  doubleClick?: boolean;
  editorRole?: string;
  onCancel?: () => void;
  onEdit?: () => void;
  disableEdit?: boolean;
  multiline?: boolean;
  startInEdit?: boolean;
} & PropsWithChildren) {
  const [edit, setEdit] = useState(startInEdit);
  const [newText, setNewText] = useState(displayText);
  useEffect(() => {
    setNewText(displayText);
  }, [displayText]); // Update when workbook changes
  function startEdit() {
    setEdit(true);
    if (!!onEdit) {
      onEdit();
    }
  }
  function cancel() {
    setNewText(displayText);
    setEdit(false);
    if (!!onCancel) {
      onCancel();
    }
  }
  function commit() {
    setDisplayText(newText);
    setEdit(false);
  }
  if (edit) {
    return (
      <Input
        className="edit"
        autoFocus={true}
        role={editorRole}
        multiline={multiline}
        fullWidth
        defaultValue={displayText}
        onChange={(event) => {
          setNewText(event.target.value);
        }}
        onBlur={() => {
          commit();
        }}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            commit();
            event.stopPropagation();
          } else if (event.key === "Escape") {
            cancel();
          }
        }}
      />
    );
  }
  return (
    <div
      onDoubleClick={!!doubleClick && !disableEdit ? startEdit : undefined}
      onClick={!doubleClick && !disableEdit ? startEdit : undefined}
      className="display"
    >
      {children}
    </div>
  );
}
